<template>
  <div>

        <div class="container" v-if="loaded">
            <div class="row">
                <div class="col-7">
                    <h2>Table of Contents</h2>
                    <ul id="toc" class="collapsed">
                        
                        <li><a href="#summarystats"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 1. Summary Statistics</a></li>
                        <li><a href="#recentchanges"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 2. Recent Changes</a></li>
                        <li><a href="#annualchanges"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 3. Annual Changes</a></li>
                        <li><a href="#landcover"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 4. Land Cover Trends</a></li>
                        <li><a href="#sustainability"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 5. Sustainability Analysis</a></li>
                        <li><a href="#atlas"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 6. Atlas</a></li>
                        <!--<li><a href="#downloads"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> Notes, Downloads, and References</a></li>-->
                    </ul>
                </div>
                <div class="col-5">
                    
                </div>
            </div>

        </div>

        
        <Quickscan v-if="loaded" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" />

        <Alerts v-if="loaded" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" />

        <Hotspots v-if="loaded" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" />        

        <LandCover v-if="loaded" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" />

        <SustainabilityIndicators v-if="loaded" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" />

        <BaselineAtlas v-if="loaded" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" />
        

        <Notes v-if="loaded" />

        <References v-if="loaded" />
  
  </div>
</template>

<script>
/* eslint-disable */
  import _ from 'lodash'; 

  import Quickscan from '@/components/factsheet/ldr/Quickscan.vue'
  import Hotspots from '@/components/factsheet/ldr/Hotspots.vue'
  import Alerts from '@/components/factsheet/ldr/Alerts.vue'
  import Indicators from '@/components/factsheet/ldr/Indicators.vue'
  import SustainabilityIndicators from '@/components/factsheet/ldr/SustainabilityIndicators.vue'
  import BaselineAtlas from '@/components/factsheet/ldr/BaselineAtlas.vue'

  import References from '@/components/factsheet/ldr/References.vue'
  import Collaboration from '@/components/factsheet/ldr/Collaboration.vue'
  import Notes from '@/components/factsheet/ldr/Notes.vue'
  import LandCover from '@/components/factsheet/ldr/LandCover.vue'
  import Downloads from '@/components/factsheet/ldr/Downloads.vue'
  
  import omnivore from "@mapbox/leaflet-omnivore";
  
  export default {
    name: 'ldr',
    props: ['location', 'factsheet', 'loaded'],
    components: {
        Quickscan, 
        Hotspots,
        Alerts,
        Indicators, 
        Collaboration,
        BaselineAtlas,
        SustainabilityIndicators,
        LandCover,
        Downloads,
        References, 
        Notes
    },
    data() {
        return {
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    }
  }
</script>


<style>
body {
    color:#666;
}
div.factsheet {
    font-size:1.5em;
}

div.factsheet h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet p {
    line-height:1.4em;
}

div.factsheet ul li {
    padding:7px 0px 7px 0px;
}

div.factsheet table td {
    color:#666;
    line-height:1.4em;
}

ul.collapsed {
    list-style-type:none;
    margin-left:0px;
    padding-left:0px;
    margin-bottom:5px;
}
ul.collapsed li {
    margin-left:0px;
}
ul.bullets {
    margin-left:20px;
    padding-left:0px;
    margin-bottom:5px;
}
ul.bullets li {
    margin-left:0px;
}
div.data-availability ul {
    list-style-type:none;
    margin-left:0px;
    padding-left:0px;
    margin-bottom:5px;
}
div.data-availability ul li {
    margin-left:0px;
}
div.factsheet-status-error {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#e50000;
    border:2px solid #e50000;
    background-color:#fff0f0;
}
div.factsheet-status-ok {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#378c07;
    border:2px solid #15b01a;
    background-color:#e8fae9
}
div.factsheet-status-notice {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#666;
    border:2px solid #ffd152;
    background-color:#ffffe4
}
div.factsheet-caution-notice {
    margin:20px 0px;
    padding:15px;
    font-size:0.8em;
    border-radius:0px;
    color:#db6504;
    border:1px solid #f97306;
    background-color:rgba(249, 115, 6, 0.05)
}
div.factsheet-caution-notice p {
    color:#db6504;
    padding:4px 0px;
    margin:0px;
    font-size:1em;
}

</style>
